import React, { useContext } from 'react';
import { Table, Icon } from 'semantic-ui-react';
import moment from 'moment-timezone';
import DataContext from '../../../contexts/DataContext';

const Participants = ({ participants }) => {
  const { user } = useContext(DataContext);
  return (
    <Table basic="very" padded stackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <Icon name="user" />
            Name
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Icon name="sign in" />
            Join time
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Icon name="sign out" />
            Leave time
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Icon name="stopwatch" />
            Duration
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {participants.map(
          (participant) => (
            <Table.Row key={`${participant.name}${participant.joinedAt}`}>
              <Table.Cell>{participant.name}</Table.Cell>
              <Table.Cell textAlign="center">
                {moment(participant.joinedAt).tz(user.timeZone).format('MM/DD/YYYY, hh:mm:ss A')}
              </Table.Cell>
              <Table.Cell textAlign="center">
                {moment(participant.leftAt).tz(user.timeZone).format('MM/DD/YYYY, hh:mm:ss A')}
              </Table.Cell>
              <Table.Cell>{`${participant.numMinutes} minute(s)`}</Table.Cell>
            </Table.Row>
          ),
        )}
      </Table.Body>
    </Table>
  );
};

export default Participants;
